import { useState, useEffect } from "react";
import { db } from "../components/Auth/firebase";
import { collection, onSnapshot, query } from "firebase/firestore";
import { useProjects } from "../context/ProjectsContext";

const useBoards = () => {
  const { activeProject } = useProjects();
  const [boards, setBoards] = useState([]);

  useEffect(() => {
    if (activeProject && activeProject.id) {
      let unsubscribe = null;

      const fetchBoards = async () => {
        const boardsCollectionRef = collection(
          db,
          `projects/${activeProject.id}/boards`
        );

        const q = query(boardsCollectionRef);

        unsubscribe = onSnapshot(q, (snapshot) => {
          const documents = [];
          snapshot.forEach((doc) => {
            documents.push({ id: doc.id, ...doc.data() });
          });
          setBoards(documents);
        });
      };

      fetchBoards().catch((error) => {
        console.error("Error fetching boards:", error);
        setBoards(null);
      });

      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
      };
    } else {
      setBoards([]);
    }
  }, [activeProject]);

  return boards;
};

export default useBoards;
